import { render } from "./ListaSinistrosAprovacaoView.vue?vue&type=template&id=7ee07a0c&scoped=true"
import script from "./ListaSinistrosAprovacaoView.vue?vue&type=script&lang=js"
export * from "./ListaSinistrosAprovacaoView.vue?vue&type=script&lang=js"

import "./ListaSinistrosAprovacaoView.vue?vue&type=style&index=0&id=7ee07a0c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee07a0c"]])

export default __exports__